
export enum Plec {
  kobieta = 'kobieta',
  mezczyzna = 'mezczyzna'
}
